import { syncSessionStorage } from '@/hooks/useSessionStorage';
import { LOCAL_FILTERS_STORAGE_MAP } from '@/context/LocalFiltersRegistry/localFiltersKeys';

/**
 * Writes local filters to sessionStorage for every module.
 * Replaces each module's filters and clears modules not present in the
 * payload so stale filters don't persist. Each write dispatches a sync
 * event so live stores (e.g. Insights) and the filter bar update.
 */
const applyLocalFiltersToStorage = (localFilters: Record<string, Record<string, unknown>>): void => {
  Object.entries(LOCAL_FILTERS_STORAGE_MAP).forEach(([key, storageKey]) => {
    const filters = localFilters[key];
    syncSessionStorage(storageKey, filters ?? {});
  });
};

export default applyLocalFiltersToStorage;
